import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowLeft_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.53033 3.46967C6.82322 3.76256 6.82322 4.23744 6.53033 4.53033L3.81066 7.25H14C14.4142 7.25 14.75 7.58579 14.75 8C14.75 8.41421 14.4142 8.75 14 8.75H3.81066L6.53033 11.4697C6.82322 11.7626 6.82322 12.2374 6.53033 12.5303C6.23744 12.8232 5.76256 12.8232 5.46967 12.5303L1.46967 8.53033C1.17678 8.23744 1.17678 7.76256 1.46967 7.46967L5.46967 3.46967C5.76256 3.17678 6.23744 3.17678 6.53033 3.46967Z"
            />
        </SvgStyled>
    );
};

export default ArrowLeft_xs;
